import React, { FC, ReactNode } from 'react';
import { isBetween, isDown, isUp } from '../../core/utils/Breakpoints';
import { useWindowSize } from '../../core/utils/Hooks';
import { BreakpointsInterface } from '../../types';

const HiddenRenderer = ({ below, above, children, windowWidth }: any) => {
  if (below && !above) {
    // when only below is present - return children when viewport is greater then given breakpoint
    return isUp(below, windowWidth) && children;
  } else if (above && !below) {
    // when only above is present - return children when viewport is smaller then given breakpoint
    return isDown(above, windowWidth) && children;
  } else if (below && above) {
    // when below and above are present - return children when viewport is between the given two breakpoints
    return isBetween(below, above, windowWidth) && children;
  } else {
    // when no condition met - render nothing
    return null;
  }
};

const Hidden: FC<HiddenProps> = ({ children, ...rest }: HiddenProps) => {
  const { width: windowWidth }: any = useWindowSize();
  const hasWindowWidth = !!windowWidth;

  return hasWindowWidth ? (
    <HiddenRenderer windowWidth={windowWidth} {...rest}>
      {children}
    </HiddenRenderer>
  ) : null;
};

export type HiddenProps = {
  /** hide children below given Breakpoint */
  below?: BreakpointsInterface;
  /** hide children above given Breakpoint */
  above?: BreakpointsInterface;
  /** Children of the Hidden Helper */
  children: ReactNode;
};

export default Hidden;
